import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { keys, map } from 'lodash';

import FiltersSelectContent from '../FiltersSelectContent';

export const messages = defineMessages({
  waitlist: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.waitlist',
    defaultMessage: 'Waitlist',
  },
  offer: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.offer',
    defaultMessage: 'Offer',
  },
  feedback: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.feedback',
    defaultMessage: 'Feedback',
  },
  appointment: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.appointment',
    defaultMessage: 'Appointment',
  },
  referral: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.referral',
    defaultMessage: 'Referral',
  },
  broadcast: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.broadcast',
    defaultMessage: 'Broadcast',
  },
  telehealth: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.telehealth',
    defaultMessage: 'Telehealth',
  },
  waitingRoom: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.waitingRoom',
    defaultMessage: 'Waiting Room',
  },
  followup: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.followup',
    defaultMessage: 'Follow-up',
  },
  outboundReferral: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.outboundReferral',
    defaultMessage: 'Outbound Referral',
  },
  form: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.form',
    defaultMessage: 'Form',
  },
  reschedule: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.reschedule',
    defaultMessage: 'Reschedule',
  },
  chat: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.chat',
    defaultMessage: 'Chat',
  },
  pinVerification: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.pinVerification',
    defaultMessage: 'Pin Verification',
  },
  stop: {
    id: 'core.FiltersDialog.components.FiltersMessageRef.stop',
    defaultMessage: 'Do not Contact',
  },
});

export function useFiltersMessageRefItems() {
  const { formatMessage } = useIntl();

  const itemIds = keys(messages) as (keyof typeof messages)[];
  return map(itemIds, (id) => ({
    _id: id,
    label: formatMessage(messages[id]),
  }));
}

const FiltersMessageRef: React.FC = () => {
  const items = useFiltersMessageRefItems();

  return <FiltersSelectContent type="messageRef" items={items} />;
};
export default FiltersMessageRef;
